import { c as _c } from "react/compiler-runtime";
import { FormInput, LocaleEnum, Popover } from '@systemeio/ui';
import { MailingSettingsEditInterface } from 'modules/profile/mailing-settings/types/mailing-settings-interface';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { LanguageSwitcher } from 'shared/components/language-switcher/language-switcher';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
interface AgreementEditorProps {
  tempState: MailingSettingsEditInterface;
  setTempState: React.Dispatch<React.SetStateAction<MailingSettingsEditInterface>>;
  locale: LocaleEnum;
  errors: Record<LocaleEnum, string>;
}
function UnsubscribeLink(t0) {
  const $ = _c(26);
  const {
    setTempState,
    tempState,
    locale,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.settings.mailing.unsubscribe_link_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.settings.mailing.unsubscribe_link_popover_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Popover label={t2} popoverClassName="w-[200px] sm:w-[350px]">{_temp}</Popover>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = language => {
      setSelectedLanguage(language);
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== selectedLanguage) {
    t6 = <LanguageSwitcher changeLanguage={t5} selectedLanguage={selectedLanguage} />;
    $[10] = selectedLanguage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = errors[selectedLanguage];
  const t8 = tempState.unsubscriptionLinkText[selectedLanguage] || "";
  let t9;
  if ($[12] !== selectedLanguage || $[13] !== setTempState) {
    t9 = e => setTempState(prev => ({
      ...prev,
      unsubscriptionLinkText: {
        ...prev.unsubscriptionLinkText,
        [selectedLanguage]: e.target.value
      }
    }));
    $[12] = selectedLanguage;
    $[13] = setTempState;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <FormInput label={t4} labelClassName="flex items-center gap-2" labelRightElement={t6} htmlFor="none" error={t7} value={t8} onChange={t9} />;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = errors[selectedLanguage];
  let t12;
  if ($[21] !== t11) {
    t12 = <FieldErrorAndDescription error={t11} />;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t12) {
    t13 = <div>{t10}{t12}</div>;
    $[23] = t10;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
export default UnsubscribeLink;